import { defineGameCard, onAppear } from '../authoring/index.js';
export const RiotBotCard = defineGameCard({
    id: 'riot_bot',
    gameplay: {
        type: 'UNIT',
        cost: 2,
        baseStats: { attack: 2, health: 1 },
    },
    presentation: {
        name: 'Боевой робот',
        description: 'При раскрытии: нанесите 1 урон сопернику.',
        glyph: {
            colors: ['#10213A', '#4D5D66', '#966B73', '#35444F', '#6C7B80'],
            rows: [
                '....................',
                '.......111111.......',
                '......12222221......',
                '......12111111......',
                '......12131331......',
                '.....1124111111.....',
                '....121145555121....',
                '...12241111114551...',
                '...11112255551111...',
                '..121.12255551.121..',
                '.125...111111...551.',
                '.1251..11111...1551.',
                '.12421.112211.14451.',
                '..111.22211425.111..',
                '......521..122......',
                '.....141....121.....',
                '....1221....1221....',
                '....1221....1221....',
                '...14441....14441...',
                '...11111....11111...',
            ],
        },
    },
    role: 'standalone_lab',
    abilities: [onAppear((ctx) => {
            const enemy = ctx.q.opponentOf(ctx.self.controllerId);
            ctx.ops.dealDamage({ kind: 'player', playerId: enemy.id }, 1);
        }, { cause: 'played' })],
});
//# sourceMappingURL=riot-bot.js.map